import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind classes safely, resolving conflicts.
 * Uses clsx for conditional class logic + tailwind-merge for
 * deduplication (e.g. p-2 + p-4 → p-4, not both).
 *
 * Used by both Core and Fitting apps.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
